var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"benefit-section-wrapper d-flex flex-column flex-md-row align-items-center"},[_vm._l((_vm.getBenefitsData),function(benefit){return [_c('benefits-section-card',{key:benefit.title,attrs:{"image":benefit.image,"title":_vm.$t(benefit.title),"text":_vm.$t(benefit.text)}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }